import React, { Component } from 'react';
import config from '../../config';
import Scroll from './Scroll';
import demo1 from '../assets/images/nearo_logo1.png';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: false,
      visibilityClass: '',
    };
  }
  toggleMenu = value => {
    this.setState({ openMenu: value });
  };

  handleScroll = () => {
    const { visibilityClass } = this.state;
    if (window.pageYOffset > 300) {
      if (visibilityClass !== 'navbar-shrink') {
        this.setState({ visibilityClass: 'navbar-shrink' });
      }
    } else {
      if (visibilityClass === 'navbar-shrink') {
        this.setState({ visibilityClass: '' });
      }
    }
  };
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { openMenu, visibilityClass } = this.state;
    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top ${visibilityClass}`}
        id={ this.props.home ? 'mainNav' : 'mainNavAlt'}
      >
        <div className="container">
          <a className="navbar-brand" href="/#page-top">
            <img src={demo1} style={{height: 50, marginRight: 10 }} alt="" />
            {config.siteTitle}
          </a>
          <button
            onClick={_ => this.toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? '' : 'collapsed'
            }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            <i className="fas fa-bars"></i>
          </button>

          <div
            className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
            id="navbarResponsive"
          >
            {
              openMenu
              && (
                <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/privacy">
                    Privacy
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/terms">
                    Terms
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/faq">
                    FAQ
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="mailto:info@nearo.co">
                    Contact
                  </a>
                </li>
              </ul>
              )
            }
          </div>
        </div>
      </nav>
    );
  }
}
